module.exports = __webpack_public_path__ + "img/d3.f2076aa7.png";